module.exports = __webpack_public_path__ + "img/logo2.cd228279.png";